import { render, staticRenderFns } from "./InspirationBriefFinder.vue?vue&type=template&id=9a893392"
import script from "./InspirationBriefFinder.vue?vue&type=script&lang=js"
export * from "./InspirationBriefFinder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports